"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var activity_overview_1 = __importDefault(require("./marquees/activity-overview"));
var audio_1 = __importDefault(require("./marquees/audio"));
var customers_1 = __importDefault(require("./marquees/customers"));
var freetier_1 = __importDefault(require("./marquees/freetier"));
var partner_1 = __importDefault(require("./marquees/partner"));
var pricing_1 = __importDefault(require("./marquees/pricing"));
var sale_1 = __importDefault(require("./marquees/sale"));
var sme_1 = __importDefault(require("./marquees/sme"));
var startup_1 = __importDefault(require("./marquees/startup"));
var student_1 = __importDefault(require("./marquees/student"));
var support_plan_1 = __importDefault(require("./marquees/support-plan"));
var support_security_1 = __importDefault(require("./marquees/support-security"));
function Animations(props) {
    var liveType = (props || {}).liveType;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        liveType === 'customers' && react_1.default.createElement(customers_1.default, null),
        liveType === 'pricing' && react_1.default.createElement(pricing_1.default, null),
        liveType === 'partner' && react_1.default.createElement(partner_1.default, null),
        liveType === 'sme' && react_1.default.createElement(sme_1.default, null),
        liveType === 'audiovb' && react_1.default.createElement(audio_1.default, null),
        liveType === 'student' && react_1.default.createElement(student_1.default, null),
        liveType === 'activityBanner' && react_1.default.createElement(activity_overview_1.default, null),
        liveType === 'startup' && react_1.default.createElement(startup_1.default, null),
        liveType === 'supportPlan' && react_1.default.createElement(support_plan_1.default, null),
        liveType === 'supportSecurity' && react_1.default.createElement(support_security_1.default, null),
        liveType === 'freetier' && react_1.default.createElement(freetier_1.default, null),
        liveType === 'sale' && react_1.default.createElement(sale_1.default, null)));
}
exports.default = Animations;
//# sourceMappingURL=Animations.js.map